import { Injectable } from '@angular/core';

import { FsApi, RequestConfig } from '@firestitch/api';

import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class StatusGroupData {

  constructor(private _api: FsApi) {}

  public get(id, query = {}, config: RequestConfig = {}): Observable<any> {
    return this._api.get(`statusgroups/${id}`, query, { key: 'statusGroup' , ...config });
  }

  public gets(data = {}, config: RequestConfig = {}): Observable<any> {
    return this._api.request('GET', 'statusgroups', data, { key: 'statusGroups', ...config });
  }

  public put(data, config: RequestConfig = {}): Observable<any> {
    return this._api.put(`statusgroups/${data.id}`, data, { key: 'statusGroup' , ...config });
  }

  public post(data, config: RequestConfig = {}): Observable<any> {
    return this._api.post('statusgroups', data, { key: 'statusGroup' , ...config });
  }

  public delete(data, config: RequestConfig = {}): Observable<any> {
    return this._api.delete(`statusgroups/${data.id}`, data, { key: 'statusGroup' , ...config });
  }

  public order(data): Observable<any> {
    return this._api.put('statusgroups/order', data, { key: null });
  }

  public save(data): Observable<any> {
    if (data.id) {
      return this.put(data);
    }

    return this.post(data);
  }


}
